import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const GridView = (props: SvgIconT.Props) => (
  <SvgIcon
    width={24}
    height={24}
    {...props}
    viewBox="0 0 24 24"
    paths={[
      'M10 6v4H6V6h4m1-1H5v6h6V5zm-1 9v4H6v-4h4m1-1H5v6h6v-6zm7-7v4h-4V6h4m1-1h-6v6h6V5zm-1 9v4h-4v-4h4m1-1h-6v6h6v-6z',
    ]}
  />
);

export default GridView;
